import sisuLogo from "../../../../design/assests/images/sisu_logo.png"

/**
 * Construye el header del PDF del cliente
 * @param {PDF} doc instancia de jsPDF
 * @param {Object} sprintData información del sprint
 * @param {number} y posición Y inicial
 * @param {string} clientName nombre del cliente
 * @param {string} clientLogo URL o path del logo del cliente
 * @returns {number} nueva posición Y después del header
 */

export const buildHeaderSection = async (
  doc,
  sprintData,
  y,
  clientName,
  clientLogo,
  periodLabel
) => {
  const pageWidth = doc.internal.pageSize.getWidth()

  const grayColor = "#535C69"

  const topMarginOffset = 5
  const headerY = y - topMarginOffset
  const sideMargin = 10
  const logoHeight = 8

  const sisuLogoWidth = 22
  const sisuLogoHeight = logoHeight
  const sisuLogoY = headerY - sisuLogoHeight / 2 + 2
  doc.addImage(
    sisuLogo,
    "PNG",
    sideMargin,
    sisuLogoY,
    sisuLogoWidth,
    sisuLogoHeight
  )

  if (clientLogo) {
    try {
      const img = new Image()
      img.crossOrigin = "anonymous"
      img.src = clientLogo

      await new Promise((resolve, reject) => {
        img.onload = resolve
        img.onerror = reject
      })

      const ratio = img.width / img.height
      const clientLogoWidth = logoHeight * ratio
      const clientLogoHeight = logoHeight
      const clientLogoY = headerY - clientLogoHeight / 2 + 2

      doc.addImage(
        img,
        "PNG",
        pageWidth - clientLogoWidth - sideMargin,
        clientLogoY,
        clientLogoWidth,
        clientLogoHeight
      )
    } catch (error) {
      console.log("No se pudo cargar logo cliente:", error)
    }
  }

  const titleY = headerY + 2
  doc.setFont("Cairo-Bold", "normal")
  doc.setFontSize(16)
  doc.setTextColor("#24292F")
  doc.text("Reporte de cliente", pageWidth / 2, titleY, { align: "center" })

  const subtitleY = titleY + 6
  const sprintLabel = `${periodLabel || ""}`
  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(10)
  doc.setTextColor(grayColor)
  doc.text(`${clientName}  |  ${sprintLabel}`, pageWidth / 2, subtitleY, {
    align: "center",
  })

  return subtitleY + 8
}
